import { render } from "./MembersTable.vue?vue&type=template&id=486f1bb7&scoped=true"
import script from "./MembersTable.vue?vue&type=script&lang=js"
export * from "./MembersTable.vue?vue&type=script&lang=js"

import "./MembersTable.vue?vue&type=style&index=0&id=486f1bb7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486f1bb7"]])

export default __exports__